import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_PROTECTION_PLANS = 'protection-plans';

export const PROTECTION_PLANS_FIELDS = [
    {
        key: 'protectionPlansHeader',
        type: NICmsContentField.EFieldType.text,
        title: 'Protection Plans Header',
        default: 'Protection Plans',
        required: true
    },
    {
        key: 'assemblyPlansHeader',
        type: NICmsContentField.EFieldType.text,
        title: 'Assembly Plans Header',
        default: 'Assembly Plans',
        required: true
    }
];

export interface IICmsConfigProtectionPlansDataContent {
    protectionPlansHeader: string;
    assemblyPlansHeader: string;
}

export interface IICmsConfigProtectionPlansData extends IConfigData<IICmsConfigProtectionPlansDataContent> {
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_PROTECTION_PLANS,
    name: 'Protection Plans configuration',
    fields: PROTECTION_PLANS_FIELDS
});